/**
 * 创建 js 标签
 * @param {*} src
 * @param {*} callback
 */
const createScript = (src, callback) => {
    // let widgetKey = src.match(/resources(\S*).js/)[1];
    let widgetKey = src.replace(/(\.\.\/)|(\/?nccloud\/resources\/)|(^\/)|(\.js)/g, ''); // 目的是取出小部件挂在window上的key值
    if (!widgetKey) {
        return false;
    }
    // widgetKey = widgetKey.substr(1);
    if (window[widgetKey]) {
        // 已经加载过script标签
        callback(widgetKey);
    } else {
        let script = document.createElement("script");
        script.src = src;
        script.type = "text/javascript";
        document.body.appendChild(script);
        script.onload = () => callback(widgetKey);
        script.onerror = script.onerror;
    }
};

export default createScript;
